module.exports = __webpack_public_path__ + "img/soft_6.838724ca.png";